import React from 'react';

const Pijltje = ({visibility}) => (
	<svg viewBox="0 0 44 44" className="af-pijl">
		<polyline points="16 10 28 22 16 34" fill="none" strokeMiterlimit="10" strokeWidth="2.5"/>
	</svg>
);

export default Pijltje;
